import React, { RefObject, useEffect, useRef } from 'react'

import { ITipProps, Tip } from '../../Tip'

export interface IRadioItemProps {
  id?: string
  name?: string
  label: string | React.ReactElement
  checked?: boolean
  rf?: string
  showTip?: boolean
  tipOptions?: ITipProps
  value: string | number | boolean
  disabled?: boolean
  onChange?: (value: string | number | boolean) => void
}

const RADIO_BASE_CLASS = 'cs-radio'
const RADIO_ACTIVE_CLASS = 'cs-radio active'
const RADIO_DISABLED_CLASS = 'cs-radio disabled'

const RadioTabItem = ({
  checked,
  id,
  label,
  name,
  rf,
  value,
  disabled,
  showTip,
  tipOptions,
  onChange,
}: IRadioItemProps) => {
  const radioRef: RefObject<HTMLInputElement> = useRef()

  useEffect(() => {
    // hack for automatic checked changes (otherwise emil css classes does not change active tab view)
    if (checked) {
      radioRef.current.click()
    }
  }, [checked])

  const handleChange = () => {
    if (disabled) {
      return
    }
    if (radioRef.current.checked === false) {
      radioRef.current.checked = true
      onChange(value)
    }
  }

  const getClass = () => {
    if (checked) {
      return RADIO_ACTIVE_CLASS
    } else if (disabled) {
      return RADIO_DISABLED_CLASS
    } else {
      return RADIO_BASE_CLASS
    }
  }

  return (
    <li role='presentation' data-testid={rf} onClick={handleChange}>
      <input
        id={id}
        type='radio'
        name={name}
        value={value.toString()}
        defaultChecked={checked}
        ref={radioRef}
        disabled={disabled}
        onChange={handleChange}
      />
      <label htmlFor={id} className={getClass()}>
        {label}
        {showTip && <Tip {...tipOptions} />}
      </label>
    </li>
  )
}

export default RadioTabItem
